(() => {
  if (App.settings.optimizeQuickReorderAndLogin) return;

  TrackApp.reorder = (() => {
    /**
     * Maps a product from Order model (com.lensway.common.order.Order) format to dataLayer format.
     * @param {Object} productInfo source object
     * @param {Number} [i] index of object in list
     * @return {Object}
     * @private
     */
    function mapProductData(productInfo, i) {
      const props = productInfo.product.properties.properties;

      const prod = {
        id: productInfo.product.id,
        groupId: productInfo.product.productGroupId || '',
        name: props.name.value,
        category: productInfo.product.type,
        categoryNameId: productInfo.product.categoryNameId || 'N/A',
        subCategory: (props.type && props.type.values.join(',')) || 'N/A',
        manufacturer: props.manufacturer.value || 'N/A',
        availability: TrackApp.getStockLevel(productInfo.item.availableQuantity),
        price: Math.round((productInfo.currentPrice / window.ua.VAT) * 100) / 100,
        listName: 'Quick reorder',
        listPosition: (i !== undefined) ? i + 1 : productInfo.listPosition,
        ribbon: TrackApp.getRibbon(productInfo.product),
      };

      if (productInfo.currentQuantity) {
        prod.quantity = productInfo.currentQuantity;
      }

      return prod;
    }

    function trackReorderView(quickOrderJson) {
      const { LENS } = quickOrderJson;
      if (LENS) {
        const lensOrderItems = LENS.orderRows.map((productInfo, i) => {
          productInfo.currentPrice = LENS?.priceInfo?.rowsPricesInfo[productInfo.tempHash]?.currentPrice
          return mapProductData(productInfo, i);
        });
        TrackApp.trackImpression('productListView', lensOrderItems);
      }
      TrackApp.trackInteraction(
        'quick reorder',
        'quick reorder exposed',
        'quick reorder exposed',
        'gaEventNonInteraction',
      );
    }

    function trackNoReorderView() {
      TrackApp.trackInteraction(
        'quick reorder',
        'quick reorder login form',
        'quick reorder login form exposed',
      );
    }

    function trackReorderCTAClick(cta = '') {
      switch (cta) {
        case 'menu cta': {
          TrackApp.trackInteraction(
            'quick reorder',
            `${cta} clicked`,
            `${cta} clicked`,
          );
          break;
        }
        default: {
          if (cta) {
            TrackApp.trackInteraction(
              'quick reorder',
              cta,
              `${cta} clicked`,
            );
          }
        }
      }
    }

    function trackReorderEmptyCartCTA() {
      TrackApp.trackInteraction(
        'quick reorder',
        'empty cart cta',
        'empty cart cta viewed',
        'gaEventNonInteraction',
      );
    }

    function trackReorderProdClick($product, quickOrderJson) {
      const link = $product.attr('href');
      const index = $product.closest('.my-pages__table').index();
      const productInfo = mapProductData(quickOrderJson.orderRows[index], index);
      dataLayer.push({
        event: 'productClick',
        product: productInfo,
      });
      window.location.href = App.global.getRedirectUrl(link);
    }

    function trackReorderCartAdd(quickOrdersJsonArr) {
      if (quickOrdersJsonArr.length > 1) {
        const orderItemsArr = quickOrdersJsonArr.map((row) => mapProductData(row));
        dataLayer.push({
          event: 'cartAddMultiple',
          products: orderItemsArr,
        });
      } else {
        dataLayer.push({
          event: 'cartAdd',
          product: mapProductData(quickOrdersJsonArr[0]),
        });
      }

      TrackApp.trackInteraction(
        'quick reorder',
        'add quick reorder to cart',
        'add quick reorder to cart',
      );
    }

    function trackOrderHistoryReorder(analyticsData) {
      if (analyticsData.productInformation.length > 1) {
        dataLayer.push({
          event: 'cartAddMultiple',
          products: TrackApp.fillProductsFields(analyticsData),
        });
      } else if (analyticsData.productInformation.length === 1) {
        dataLayer.push({
          event: 'cartAdd',
          product: TrackApp.fillProductsFields(analyticsData),
        });
      }
    }

    function init() {
      // Remove and add init logic here if needed
    }

    return {
      init,
      trackOrderHistoryReorder,
      trackReorderCartAdd,
      trackReorderProdClick,
      trackReorderView,
      trackNoReorderView,
      trackReorderCTAClick,
      trackReorderEmptyCartCTA,
    };
  })();
})();
